/**
 * The sliding scale tab is gated on the same native tour model flag svc-tour
 * uses, so Admin only offers it where the endpoints behind it are enabled. On
 * in staging, off everywhere else while the model is being built out.
 *
 * Defaults to off: an environment that has not set the flag does not get the
 * tab.
 */
export function isSlidingScaleEnabled(): boolean {
  return window.configs?.ENABLE_NATIVE_TOUR_MODEL === 'true';
}

export const SLIDING_SCALE_TAB_TYPE = 'sliding-scale';

export const SLIDING_SCALE_TAB_TITLE = 'Sliding scale';
